(function () {
  'use strict';

  var LENS_BY_LINE = {
    'aura': 'Red',
    'iris': 'Orange',
    'nova': 'Clear',
    'velo': 'Clear'
  };

  function getProductLine() {
    var h1 = document.querySelector('h1');
    if (!h1) return null;
    var text = h1.textContent || '';
    var line = text.split('|')[0].trim().toLowerCase();
    return line;
  }

  function findWidget() {
    return document.querySelector('king-linked-options-product');
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Styled in assets/lumvera-pdp.css: grey "Frame:"/"Lenses:" keys, dark values, light "/" separator.
  function updateLabel(labelEl, frameValue) {
    if (!labelEl || !frameValue) return;
    var line = getProductLine();
    var lens = line && LENS_BY_LINE[line] ? LENS_BY_LINE[line] : null;
    labelEl.innerHTML =
      '<span class="lv-fl-key">Frame:</span> ' + escapeHtml(frameValue) +
      (lens ? '<span class="lv-fl-sep">/</span><span class="lv-fl-key">Lenses:</span> ' + escapeHtml(lens) : '');
  }

  function setup(widget) {
    if (widget.dataset.lumveraDecorated) return;

    var selectedEl = widget.querySelector('.lv-option-label__selected');
    if (!selectedEl) return;

    widget.dataset.lumveraDecorated = 'true';

    var heading = document.createElement('div');
    heading.className = 'lumvera-select-color-heading';
    heading.textContent = 'Select color';
    widget.parentNode.insertBefore(heading, widget);

    var label = document.createElement('div');
    label.className = 'lumvera-frame-lens-label';
    widget.parentNode.insertBefore(label, widget.nextSibling);

    function refresh() {
      var sel = widget.querySelector('.lv-option-label__selected');
      if (sel) updateLabel(label, sel.textContent.trim());
    }

    refresh();

    var observer = new MutationObserver(refresh);
    observer.observe(widget, { characterData: true, childList: true, subtree: true, attributes: true });
  }

  function tryInject(attemptsLeft) {
    var widget = findWidget();
    if (widget && widget.querySelector('.lv-option-label__selected')) {
      setup(widget);
      return;
    }
    if (attemptsLeft <= 0) return;
    setTimeout(function () { tryInject(attemptsLeft - 1); }, 300);
  }

  // "Save $X" pill after the product page price, computed from the compare-at and sale prices the theme
  // already rendered. Re-run on DOM changes since the theme can re-render the price block.
  function parsePrice(el) {
    if (!el) return NaN;
    return parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
  }

  function addSavePill() {
    var priceList = document.querySelector('.product-info .product-info__price price-list');
    if (!priceList) return;

    var sale = parsePrice(priceList.querySelector('sale-price'));
    var compare = parsePrice(priceList.querySelector('compare-at-price'));
    var saving = compare - sale;
    var text = saving > 0 ? 'Save $' + saving.toFixed(2) : '';

    var pill = priceList.querySelector('.lv-save-pill');
    if (!text) {
      if (pill) pill.remove();
      return;
    }
    if (pill && pill.textContent === text) return;
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'lv-save-pill';
      priceList.appendChild(pill);
    }
    pill.textContent = text;
  }

  function init() {
    addSavePill();
    tryInject(20);

    var bodyObserver = new MutationObserver(function () {
      addSavePill();
      var widget = findWidget();
      if (widget && !widget.dataset.lumveraDecorated) {
        tryInject(10);
      }
    });
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Lumvera cart controller. Replaces the old LumveraCart and Shipping Protection blocks of this file.

  Two jobs:

  1. Reliable cart. +, -, remove, "Add" on the recommendation cards and the Shipping Protection toggle are sent to
     Shopify one at a time, and the drawer is redrawn from Shopify's render of the real cart after each one, so the
     drawer always matches checkout. (Rebuilt Oct 2026: the old optimistic model could leave hidden duplicate lines.)

  2. Kaching bundles on every add. Kaching only discounts cart lines that carry its hidden "__kaching_bundles"
     property, which its product page widget adds. Pairs added any other way (quick add, cart cards, the + button)
     got no discount. After every cart change this script groups all pairs into Kaching bundles itself:
     as many of the largest bundle as fit (3 = "Buy 2, get 1 free!"), then the next size down (2 = "2 Pairs"), with
     the priciest frames inside bundles and any single leftover pair the cheapest one. Kaching prices each bundle at a
     flat total, so this is always the lowest price.

     Bundle format (copied from the widget's own adds and confirmed against Kaching's discount):
       main line, qty 1:  {"deal","pp":<product id>,"main":true,"market","v","id","bid":<deal bar id>}
       other lines:       {"id","deal","v","collectionBreaksProduct":true}   (any qty)
     The deal id, version, bar ids and bundle prices are read from the Kaching settings JSON on product pages, cached
     per market in localStorage, and fetched in the background from a product page when a visitor hasn't opened one.
     If Kaching's deal is edited (new version), the first sync that gets no discount refreshes the cached settings.

  All cart writes use Kaching's unwrapped fetch so its own cart interceptor doesn't rewrite them.
*/
(function () {
  'use strict';

  var KC_PROP = '__kaching_bundles';
  var KC_CACHE_PREFIX = 'lv_kc2_cfg_';
  var KC_MAX_AGE = 6 * 60 * 60 * 1000;
  var SP_OPT_OUT_KEY = 'lv_sp_opted_out';
  var SP_OPT_IN_KEY = 'lv_sp_opted_in';
  var FLUSH_DELAY = 220;

  // ---------------------------------------------------------------------------------------------------------------
  // Network

  // Shopify answers 429 when a cart is hit too fast; wait a little and try again (up to 3 times).
  function rawFetch(url, options, attempt) {
    var f = window.__kachingBundlesRawFetch || window.fetch;
    attempt = attempt || 0;
    return f(url, options).then(function (r) {
      if (r.status !== 429 || attempt >= 3) return r;
      return new Promise(function (resolve) { setTimeout(resolve, 600 * (attempt + 1)); })
        .then(function () { return rawFetch(url, options, attempt + 1); });
    });
  }

  function postJSON(url, body) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        var error = new Error(url + ' ' + r.status);
        error.status = r.status;
        throw error;
      }
      return r.json();
    });
  }

  function fetchCart() {
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('/cart.js ' + r.status);
      return r.json();
    }).then(function (cart) {
      if (!cart || !cart.items) throw new Error('/cart.js bad response');
      return cart;
    });
  }

  function getSectionId() {
    var drawer = document.getElementById('cart-drawer');
    var wrapper = drawer && drawer.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  function storageGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }

  function storageSet(store, key, value) {
    try {
      if (value == null) window[store].removeItem(key); else window[store].setItem(key, value);
    } catch (e) {}
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Shipping Protection settings (rendered by sections/cart-drawer.liquid). Its price, for the instant total, is
  // read from the cart line or from the product's JSON (preload()).

  var spPrice = 0;

  function getSpConfig() {
    var el = document.querySelector('[data-lv-sp-config]');
    if (!el) return null;
    return {
      variantId: String(el.getAttribute('data-variant-id')),
      productId: String(el.getAttribute('data-product-id')),
      price: parseInt(el.getAttribute('data-price'), 10) || spPrice,
      autoAdd: el.getAttribute('data-auto-add') === 'true'
    };
  }

  function isSpLine(item, sp) {
    return sp ? String(item.variant_id) === sp.variantId : item.handle === 'shipping-protection';
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Kaching deal settings

  function currentMarketId() {
    var el = document.getElementById('kaching-bundles-config');
    if (!el) return null;
    try { return String(JSON.parse(el.textContent).marketId); } catch (e) { return null; }
  }

  function parseDealSettings(root, marketId) {
    if (!marketId) return null;
    // Kaching renders one of these per deal (one per market) on product pages.
    var scripts = root.querySelectorAll('script.kaching-bundles-deal-block-settings');

    for (var i = 0; i < scripts.length; i++) {
      var deal;
      try { deal = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
      if (String(deal.marketId) !== marketId) continue;
      if ((deal.excludedMarketIds || []).map(String).indexOf(marketId) !== -1) continue;
      if (!deal.nanoId || !deal.versionId) continue;

      var bars = [];
      (deal.dealBars || []).forEach(function (bar) {
        var size = 0;
        var price = null;
        if (bar.dealBarType === 'bxgy') {
          size = (bar.buyQuantity || 0) + (bar.getQuantity || 0);
          if (bar.buyDiscountType === 'specific' && bar.getDiscountType === 'percentage' && bar.getDiscountValue === 100) {
            price = Math.round(bar.buyDiscountValue * 100);
          }
        } else if (bar.dealBarType === 'quantity-break') {
          size = bar.quantity || 0;
          if (bar.discountType === 'specific') price = Math.round(bar.discountValue * 100);
        }
        if (size >= 2 && bar.id) bars.push({ id: bar.id, size: size, price: price, type: bar.dealBarType });
      });
      if (!bars.length) continue;
      bars.sort(function (a, b) { return b.size - a.size; });

      var excluded = [];
      var breaks = deal.collectionBreaks;
      if (breaks && breaks.visibility === 'excluded-products') {
        (breaks.excludedProducts || []).forEach(function (p) {
          excluded.push(String(p.id).split('/').pop());
        });
      }

      return { market: marketId, deal: deal.nanoId, v: deal.versionId, bars: bars, excluded: excluded, savedAt: Date.now() };
    }
    return null;
  }

  var kcConfig = null;
  var kcLoading = null;

  function saveConfig(config) {
    kcConfig = config;
    storageSet('localStorage', KC_CACHE_PREFIX + config.market, JSON.stringify(config));
  }

  function invalidateConfig() {
    if (kcConfig) storageSet('localStorage', KC_CACHE_PREFIX + kcConfig.market, null);
    kcConfig = null;
  }

  // Resolves to the deal settings for the visitor's market, or null if they can't be found (cart still works, just
  // without bundle tags). productUrl is any eyewear product page to read them from when nothing is cached.
  function loadConfig(productUrl, forceFetch) {
    var marketId = currentMarketId();
    if (!marketId) return Promise.resolve(null);

    if (!forceFetch) {
      if (kcConfig && kcConfig.market === marketId) return Promise.resolve(kcConfig);

      var fromPage = parseDealSettings(document, marketId);
      if (fromPage) {
        saveConfig(fromPage);
        return Promise.resolve(fromPage);
      }

      var cached = null;
      try { cached = JSON.parse(storageGet('localStorage', KC_CACHE_PREFIX + marketId)); } catch (e) {}
      if (cached && cached.market === marketId && Date.now() - cached.savedAt < KC_MAX_AGE) {
        kcConfig = cached;
        return Promise.resolve(cached);
      }
    }

    if (!productUrl) return Promise.resolve(null);
    if (kcLoading) return kcLoading;

    kcLoading = rawFetch(productUrl.split('?')[0], { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var config = parseDealSettings(doc, marketId);
        if (config) saveConfig(config);
        return config;
      })
      .catch(function () { return null; })
      .then(function (config) {
        kcLoading = null;
        return config;
      });
    return kcLoading;
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Model: the cart the visitor should see. units = one entry per pair, oldest first.

  var meta = {}; // variantId -> { productId, price, title, image, url }

  function rememberMeta(variantId, info) {
    var key = String(variantId);
    var current = meta[key] || {};
    Object.keys(info).forEach(function (k) {
      if (info[k] != null && info[k] !== '') current[k] = info[k];
    });
    meta[key] = current;
  }

  var serverCart = null;
  var model = null;          // { units: [variantId,...] }
  var localVersion = 0;      // bumped by every visitor action
  var syncedVersion = 0;     // localVersion the server has caught up with

  function modelFromCart(cart) {
    var sp = getSpConfig();
    var units = [];
    cart.items.slice().reverse().forEach(function (item) {
      if (isSpLine(item, sp)) {
        spPrice = item.price;
        return;
      }
      rememberMeta(item.variant_id, {
        productId: String(item.product_id),
        price: item.price,
        title: item.product_title,
        image: item.image,
        url: item.url
      });
      for (var i = 0; i < item.quantity; i++) units.push(String(item.variant_id));
    });
    return { units: units };
  }

  function spInCart(cart) {
    var sp = getSpConfig();
    return !!(cart && cart.items.some(function (item) { return isSpLine(item, sp); }));
  }

  function spWanted(pairCount) {
    var sp = getSpConfig();
    if (!sp || pairCount === 0) return false;
    if (storageGet('sessionStorage', SP_OPT_OUT_KEY) === '1') return false;
    return sp.autoAdd || storageGet('sessionStorage', SP_OPT_IN_KEY) === '1' || spInCart(serverCart);
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Bundle plan

  function unitPrice(variantId) {
    return (meta[variantId] && meta[variantId].price) || 0;
  }

  // Order Shopify will list the planned lines in after the sync: lines it has to add come first (in plan order, since
  // they're sent reversed and Shopify lists the newest first), then the lines that stay, in their current order.
  function predictedLineOrder(plan, cart) {
    var sp = getSpConfig();
    var position = {};
    (cart ? cart.items : []).forEach(function (item, index) {
      if (!isSpLine(item, sp)) position[lineSignature(item.variant_id, item.properties)] = index;
    });
    var added = [];
    var kept = [];
    plan.lines.forEach(function (line) {
      var at = position[lineSignature(line.id, line.properties)];
      if (at == null) added.push(line); else kept.push({ line: line, at: at });
    });
    kept.sort(function (a, b) { return a.at - b.at; });
    return added.concat(kept.map(function (k) { return k.line; }));
  }

  // Per-row prices for the drawer, split the way Kaching does it (checked against real carts). Within a bundle, in the
  // order Shopify lists the lines: for "Buy 2, get 1 free!" the cheapest pair is free (on a tie, the first listed);
  // the paying pairs share the bundle price in proportion to their prices, cents rounded down, remainder on the last.
  // Returns { variantId: { final, original } } in cents.
  function estimateRows(plan, config, cart) {
    var rows = {};
    function add(variantId, final) {
      var row = rows[variantId] || (rows[variantId] = { final: 0, original: 0 });
      row.final += final;
      row.original += unitPrice(variantId);
    }

    var bundles = {};
    var order = [];
    predictedLineOrder(plan, cart).forEach(function (line) {
      var raw = line.properties[KC_PROP];
      var data = raw ? JSON.parse(raw) : null;
      var variantId = String(line.id);
      if (!data) {
        for (var i = 0; i < line.quantity; i++) add(variantId, unitPrice(variantId));
        return;
      }
      var bundle = bundles[data.id];
      if (!bundle) { bundle = bundles[data.id] = { units: [], bid: null }; order.push(data.id); }
      if (data.main) bundle.bid = data.bid;
      for (var j = 0; j < line.quantity; j++) bundle.units.push(variantId);
    });

    order.forEach(function (id) {
      var bundle = bundles[id];
      var bar = config && config.bars.filter(function (b) { return b.id === bundle.bid; })[0];
      if (!bar || bar.price == null) {
        bundle.units.forEach(function (v) { add(v, unitPrice(v)); });
        return;
      }
      var paying = bundle.units.slice();
      if (bar.type === 'bxgy') {
        var free = 0;
        paying.forEach(function (v, i) { if (unitPrice(v) < unitPrice(paying[free])) free = i; });
        add(paying[free], 0);
        paying.splice(free, 1);
      }
      var value = paying.reduce(function (sum, v) { return sum + unitPrice(v); }, 0);
      var left = bar.price;
      paying.forEach(function (v, i) {
        var share = i === paying.length - 1 ? left : Math.floor(bar.price * unitPrice(v) / value);
        left -= share;
        add(v, share);
      });
    });
    return rows;
  }

  // Returns { lines: [{ id, quantity, properties }], estimate, bundles }.
  function buildPlan(units, config) {
    var lines = [];
    var estimate = 0;
    var bundleCount = 0;

    function pushGrouped(list, propsFor) {
      var counts = {};
      var order = [];
      list.forEach(function (variantId) {
        if (!counts[variantId]) { counts[variantId] = 0; order.push(variantId); }
        counts[variantId]++;
      });
      order.forEach(function (variantId) {
        lines.push({ id: Number(variantId), quantity: counts[variantId], properties: propsFor ? propsFor(variantId) : {} });
      });
    }

    var eligible = [];
    var other = [];
    units.forEach(function (variantId) {
      var productId = meta[variantId] && meta[variantId].productId;
      if (config && productId && config.excluded.indexOf(String(productId)) === -1) eligible.push(variantId);
      else other.push(variantId);
    });

    // Priciest frames go into bundles first; Kaching charges each bundle a flat total.
    var remaining = eligible
      .map(function (variantId, index) { return { variantId: variantId, index: index }; })
      .sort(function (a, b) { return (unitPrice(b.variantId) - unitPrice(a.variantId)) || (a.index - b.index); })
      .map(function (entry) { return entry.variantId; });

    if (config) {
      config.bars.forEach(function (bar) {
        while (remaining.length >= bar.size) {
          var group = remaining.slice(0, bar.size);
          var groupValue = group.reduce(function (sum, v) { return sum + unitPrice(v); }, 0);
          if (bar.price != null && bar.price >= groupValue) break;
          remaining = remaining.slice(bar.size);

          bundleCount++;
          var bundleId = 'LV' + bundleCount;
          var main = group[0];
          lines.push({
            id: Number(main),
            quantity: 1,
            properties: makeProps({
              deal: config.deal,
              pp: Number(meta[main].productId),
              main: true,
              market: Number(config.market),
              v: config.v,
              id: bundleId,
              bid: bar.id
            })
          });
          pushGrouped(group.slice(1), function () {
            return makeProps({ id: bundleId, deal: config.deal, v: config.v, collectionBreaksProduct: true });
          });
          estimate += bar.price != null ? bar.price : groupValue;
        }
      });
    }

    var singles = remaining.concat(other);
    pushGrouped(singles, null);
    singles.forEach(function (v) { estimate += unitPrice(v); });

    return { lines: lines, estimate: estimate, bundles: bundleCount };
  }

  function makeProps(data) {
    var props = {};
    props[KC_PROP] = JSON.stringify(data);
    return props;
  }

  function lineSignature(variantId, properties) {
    return String(variantId) + '|' + ((properties && properties[KC_PROP]) || '');
  }

  // A cart the Kaching widget just built is already correct if every bundle is complete and the bundle sizes match
  // the plan, so it's left alone instead of being rebuilt.
  function existingBundlesValid(cart, config, plan) {
    if (!config) return false;
    var sp = getSpConfig();
    var groups = {};
    var untagged = 0;
    var ok = true;

    cart.items.forEach(function (item) {
      if (isSpLine(item, sp)) return;
      var raw = item.properties && item.properties[KC_PROP];
      if (!raw) { untagged += item.quantity; return; }
      var data;
      try { data = JSON.parse(raw); } catch (e) { ok = false; return; }
      if (data.deal !== config.deal || data.v !== config.v || !data.id) { ok = false; return; }
      var group = groups[data.id] || (groups[data.id] = { units: 0, mains: 0, bid: null });
      group.units += item.quantity;
      if (data.main) {
        group.mains += item.quantity;
        group.bid = data.bid;
        if (String(data.market) !== config.market) ok = false;
      }
    });
    if (!ok) return false;

    var sizes = [];
    Object.keys(groups).forEach(function (id) {
      var group = groups[id];
      var bar = config.bars.filter(function (b) { return b.id === group.bid; })[0];
      if (group.mains !== 1 || !bar || bar.size !== group.units) ok = false;
      sizes.push(group.units);
    });
    if (!ok) return false;

    var planned = [];
    plan.lines.forEach(function (line) {
      var data = line.properties[KC_PROP] && JSON.parse(line.properties[KC_PROP]);
      if (data && data.main) {
        var bar = config.bars.filter(function (b) { return b.id === data.bid; })[0];
        planned.push(bar.size);
      }
    });
    if (sizes.sort().join(',') !== planned.sort().join(',') || untagged > 1) return false;

    // The frames left at full price must be the cheapest ones, as in the plan.
    var cartSingles = 0;
    cart.items.forEach(function (item) {
      if (!isSpLine(item, sp) && !(item.properties && item.properties[KC_PROP])) cartSingles += item.price * item.quantity;
    });
    var planSingles = 0;
    plan.lines.forEach(function (line) {
      if (!line.properties[KC_PROP]) planSingles += unitPrice(String(line.id)) * line.quantity;
    });
    return cartSingles <= planSingles;
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Engine. Every change is sent to Shopify one at a time (a queue), and after each one the drawer is redrawn from
  // Shopify's own render of the real cart. Nothing is guessed locally, so the drawer always matches checkout.
  //
  // Rows are grouped by frame (variant) in sections/cart-drawer.liquid, so every action works on ALL of that
  // variant's real cart lines, looked up fresh from /cart.js right before acting (keys go stale when Kaching or a
  // re-bundle rewrites lines). Trash removes every line of the frame; - takes one unit off; + adds one.
  //
  // Kaching bundles: after any change, rebundle() re-tags the pairs so Kaching discounts them. It always ADDS the
  // re-tagged lines first and only removes the old ones once the add is confirmed, so the cart is never emptied and
  // never ends up with extra pairs.

  var queue = Promise.resolve();
  var pending = 0;

  function setBusy(on) {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.toggle('lv-busy', on);
  }

  function enqueue(task) {
    pending++;
    setBusy(true);
    var run = queue
      .then(task)
      .catch(function (error) {
        if (window.console) console.warn('[Lumvera cart]', error);
      })
      .then(function () {
        // The last change in a burst of clicks re-bundles and tidies protection, from a fresh read of the cart.
        if (pending === 1) return fetchCart().then(afterChange);
      })
      .catch(function (error) {
        if (window.console) console.warn('[Lumvera cart]', error);
      })
      .then(function () { return render(); })
      .catch(function () {})
      .then(function () {
        pending--;
        if (!pending) setBusy(false);
      });
    queue = run;
    return run;
  }

  function pairLines(cart, variantId) {
    var sp = getSpConfig();
    return cart.items.filter(function (item) {
      return !isSpLine(item, sp) && (variantId == null || String(item.variant_id) === String(variantId));
    });
  }

  function pairCount(cart) {
    return pairLines(cart).reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }

  // Lines whose signature isn't in the plan go to 0; planned lines get the planned quantity.
  function diffAgainstPlan(cart, plan) {
    var sp = getSpConfig();
    var planned = {};
    plan.lines.forEach(function (line) { planned[lineSignature(line.id, line.properties)] = line; });
    var updates = {};
    var seen = {};
    cart.items.forEach(function (item) {
      if (isSpLine(item, sp)) return;
      var sig = lineSignature(item.variant_id, item.properties);
      var target = planned[sig];
      if (!target || seen[sig]) updates[item.key] = 0;
      else if (target.quantity !== item.quantity) updates[item.key] = target.quantity;
      seen[sig] = true;
    });
    var adds = plan.lines.filter(function (line) { return !seen[lineSignature(line.id, line.properties)]; });
    return { updates: updates, adds: adds };
  }

  // Any product page in the cart, to read Kaching's deal settings from when they aren't cached.
  function firstProductUrl(units) {
    for (var i = 0; i < units.length; i++) {
      var info = meta[units[i]];
      if (info && info.url) return info.url;
    }
    return null;
  }

  // Pair quantities per line signature (frame + bundle tag), Shipping Protection excluded.
  function sigQuantities(cart) {
    var sp = getSpConfig();
    var q = {};
    cart.items.forEach(function (item) {
      if (isSpLine(item, sp)) return;
      var sig = lineSignature(item.variant_id, item.properties);
      q[sig] = (q[sig] || 0) + item.quantity;
    });
    return q;
  }

  // True when every line in `lines` is in the cart with at least that quantity.
  function linesLanded(cart, lines) {
    var have = {};
    cart.items.forEach(function (item) {
      var sig = lineSignature(item.variant_id, item.properties);
      have[sig] = (have[sig] || 0) + item.quantity;
    });
    return lines.every(function (line) {
      return (have[lineSignature(line.id, line.properties)] || 0) >= line.quantity;
    });
  }

  // Pairs per frame, e.g. { "514974...": 2 }.
  function countsByVariant(cart) {
    var counts = {};
    pairLines(cart).forEach(function (item) {
      var id = String(item.variant_id);
      counts[id] = (counts[id] || 0) + item.quantity;
    });
    return counts;
  }

  // Posts and then reads the cart back. A failed or lost reply is not trusted either way: the cart is re-read and
  // the caller checks what actually landed.
  function postThenRead(url, body) {
    return postJSON(url, body).catch(function () { return null; }).then(fetchCart);
  }

  // One pass: plan from the cart as it is NOW, add the re-tagged lines first, then (only once they're confirmed in
  // the cart) set the lines that were there before to exactly what the plan says. Lines this pass didn't know about
  // (added meanwhile by the Kaching widget or another tab) are never removed; the next pass plans them in.
  // ourSigs collects every line signature the engine has added during this re-bundle.
  function rebundleOnce(cart, ourSigs) {
    var sp = getSpConfig();
    var units = modelFromCart(cart).units;
    return loadConfig(firstProductUrl(units)).then(function (config) {
      if (!config) return { cart: cart, done: true };
      var plan = buildPlan(units, config);
      if (existingBundlesValid(cart, config, plan)) return { cart: cart, done: true };

      var diff = diffAgainstPlan(cart, plan);
      if (!diff.adds.length && !Object.keys(diff.updates).length) return { cart: cart, done: true };

      // Lines are matched by what they are (frame + bundle tag), never by Shopify's line key: Shopify gives a line a
      // new key whenever its discount changes, which happens on every re-bundle.
      var beforeQty = sigQuantities(cart);
      var addedQty = {};
      diff.adds.forEach(function (line) {
        var sig = lineSignature(line.id, line.properties);
        addedQty[sig] = (addedQty[sig] || 0) + line.quantity;
        ourSigs[sig] = true;
      });

      var step = diff.adds.length
        ? postThenRead('/cart/add.js', { items: diff.adds.slice().reverse() })
        : Promise.resolve(cart);

      return step.then(function (afterAdd) {
        var afterQty = sigQuantities(afterAdd);
        // Anything beyond what was there plus what this pass added came from somewhere else (Kaching widget, a tab).
        var foreign = Object.keys(afterQty).some(function (sig) {
          return afterQty[sig] > (beforeQty[sig] || 0) + (addedQty[sig] || 0);
        });
        if (!foreign && linesLanded(afterAdd, diff.adds)) {
          var updates = diffAgainstPlan(afterAdd, plan).updates;
          if (!Object.keys(updates).length) return { cart: afterAdd, done: false };
          return postThenRead('/cart/update.js', { updates: updates }).then(function (fresh) {
            return { cart: fresh, done: false };
          });
        }
        // Something else changed the cart, or the add didn't land as planned: take back only what this pass added,
        // then plan again from a fresh read.
        var undo = {};
        afterAdd.items.forEach(function (item) {
          if (isSpLine(item, sp)) return;
          var sig = lineSignature(item.variant_id, item.properties);
          if (!addedQty[sig]) return;
          var keep = Math.max(0, item.quantity - addedQty[sig]);
          if (keep !== item.quantity) undo[item.key] = keep;
        });
        if (!Object.keys(undo).length) return { cart: afterAdd, done: false };
        return postThenRead('/cart/update.js', { updates: undo }).then(function (fresh) {
          return { cart: fresh, done: false };
        });
      });
    });
  }

  // Re-bundling must never change how many pairs of each frame are in the cart. If a pass left extra pairs of a
  // frame (a request half-failed), the extras are taken off the lines the engine itself added. Extras on lines the
  // engine didn't add came from the visitor or Kaching, so they are accepted as the new count.
  function trimSurplus(cart, base, ourSigs) {
    var counts = countsByVariant(cart);
    var updates = {};
    Object.keys(counts).forEach(function (id) {
      var extra = counts[id] - (base[id] || 0);
      if (extra <= 0) { base[id] = counts[id]; return; }
      pairLines(cart, id).forEach(function (item) {
        if (!extra || !ourSigs[lineSignature(item.variant_id, item.properties)]) return;
        var take = Math.min(item.quantity, extra);
        updates[item.key] = item.quantity - take;
        extra -= take;
      });
      base[id] = counts[id] - (counts[id] - (base[id] || 0) - extra);
    });
    Object.keys(base).forEach(function (id) { if (!counts[id]) base[id] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return postThenRead('/cart/update.js', { updates: updates });
  }

  // Re-bundle until the cart matches its plan (normally one pass, plus one pass that confirms it). Each pass starts
  // from a fresh read of the cart, so nothing is ever based on an old copy.
  function rebundle() {
    var passes = 0;
    var ourSigs = {};
    var base = null;
    function pass(current) {
      passes++;
      var ready = base ? trimSurplus(current, base, ourSigs) : Promise.resolve(current);
      if (!base) base = countsByVariant(current);
      return ready.then(function (cart) {
        return rebundleOnce(cart, ourSigs).then(function (result) {
          if (result.done) return result.cart;
          if (passes >= 3) return trimSurplus(result.cart, base, ourSigs);
          return fetchCart().then(pass);
        });
      });
    }
    return fetchCart().then(pass);
  }

  // Shipping Protection is only in the cart while there are pairs.
  function tidyProtection(cart) {
    var sp = getSpConfig();
    if (!sp || pairCount(cart) > 0) return cart;
    var updates = {};
    cart.items.forEach(function (item) { if (isSpLine(item, sp)) updates[item.key] = 0; });
    if (!Object.keys(updates).length) return cart;
    return postThenRead('/cart/update.js', { updates: updates });
  }

  // After a change: re-bundle and tidy protection. enqueue() runs this once after the last of a burst of clicks, so
  // fast clicking doesn't build a backlog.
  function afterChange(cart) {
    return rebundle(cart).then(tidyProtection);
  }

  function render() {
    return fetchCart().then(function (cart) {
      serverCart = cart;
      model = modelFromCart(cart);
      return refreshDrawer().then(function () {
        updateCountBubbles(model.units.length);
        renderProgress(model.units.length, kcConfig);
        document.dispatchEvent(new CustomEvent('lumvera:cart-synced', { detail: { cart: cart } }));
      });
    });
  }

  // ---------------------------------------------------------------------------------------------------------------
  // Drawer rendering

  var serverCart = null;
  var model = null;

  function swapDrawerHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshDrawer = doc.getElementById('cart-drawer');
    var currentDrawer = document.getElementById('cart-drawer');
    if (!freshDrawer || !currentDrawer) return;

    var currentList = currentDrawer.querySelector('[data-lumvera-recommendations-list]');
    var preservedListHtml = currentList ? currentList.innerHTML : '';
    var preservedScroll = currentList ? currentList.scrollLeft : 0;

    currentDrawer.innerHTML = freshDrawer.innerHTML;

    var newList = currentDrawer.querySelector('[data-lumvera-recommendations-list]');
    if (newList && preservedListHtml) {
      newList.innerHTML = preservedListHtml;
      newList.scrollLeft = preservedScroll;
    }

    renderProgress(model ? model.units.length : 0, kcConfig);
    document.dispatchEvent(new CustomEvent('cart:refreshed'));
  }

  function refreshDrawer() {
    var sectionId = getSectionId();
    return rawFetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId) + '&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections[sectionId]) swapDrawerHtml(sections[sectionId]);
      });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCountBubbles(count) {
    var bubbles = document.querySelectorAll('cart-count');
    for (var i = 0; i < bubbles.length; i++) {
      if (!bubbles[i].closest('.empty-state')) bubbles[i].textContent = count;
    }
  }

  function barFor(config, size) {
    if (!config) return null;
    return config.bars.filter(function (b) { return b.size === size; })[0] || null;
  }

  // Same markup as snippets/second-pair-progress.liquid, with the bundle prices taken from Kaching's settings so the
  // copy is right in every market.
  function renderProgress(count) {
    var block = document.querySelector('#cart-drawer .lumvera-second-pair-progress');
    if (!block) return;

    var title;
    var progress;
    var subtitle;
    if (count <= 1) {
      title = 'Add 1 more pair';
      progress = 0.5;
      subtitle = 'Get your <strong>2nd pair 50% off</strong>';
    } else {
      title = '2nd pair 50% off unlocked';
      progress = 1;
      subtitle = '<strong>2nd pair 50% off</strong> applied to your order';
    }

    var titleEl = block.querySelector('.lumvera-second-pair-progress__title');
    var barEl = block.querySelector('.progress-bar');
    var subtitleEl = block.querySelector('.lumvera-second-pair-progress__subtitle');
    if (titleEl) titleEl.textContent = title;
    if (barEl) {
      barEl.style.setProperty('--progress', progress);
      barEl.setAttribute('aria-valuemax', '2');
      barEl.setAttribute('aria-valuenow', String(Math.min(count, 2)));
    }
    if (subtitleEl && subtitleEl.innerHTML !== subtitle) subtitleEl.innerHTML = subtitle;
  }


  (function injectStyles() {
    var style = document.createElement('style');
    style.textContent =
      '#cart-drawer.lv-busy .cart-drawer__line-items,#cart-drawer.lv-busy [data-lv-sp],#cart-drawer.lv-busy [slot="footer"] .justify-between' +
      '{opacity:.55;pointer-events:none;transition:opacity .15s ease;}';
    document.head.appendChild(style);
  })();

  // ---------------------------------------------------------------------------------------------------------------
  // Visitor actions

  function addOne(variantId, info) {
    if (info) rememberMeta(variantId, info);
    return enqueue(function () {
      return postThenRead('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
    });
  }

  // Sets the number of pairs of one frame, taking units off untagged lines first. `target` gets the frame's current
  // count (read inside the queue, so rapid clicks all count) and returns the count wanted.
  function changeQuantity(variantId, target) {
    return enqueue(function () {
      return fetchCart().then(function (cart) {
        var lines = pairLines(cart, variantId);
        var current = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        var wanted = Math.max(0, target(current));
        if (wanted === current) return cart;
        if (wanted > current) {
          return postThenRead('/cart/add.js', { items: [{ id: Number(variantId), quantity: wanted - current }] });
        }
        var toRemove = current - wanted;
        var updates = {};
        lines.slice().sort(function (a, b) {
          var at = a.properties && a.properties[KC_PROP] ? 1 : 0;
          var bt = b.properties && b.properties[KC_PROP] ? 1 : 0;
          return at - bt;
        }).forEach(function (item) {
          if (!toRemove) return;
          var take = Math.min(item.quantity, toRemove);
          updates[item.key] = item.quantity - take;
          toRemove -= take;
        });
        return postThenRead('/cart/update.js', { updates: updates });
      });
    });
  }

  function setQuantity(variantId, target) {
    return changeQuantity(variantId, function () { return target; });
  }

  function removeOne(variantId) {
    return changeQuantity(variantId, function (current) { return current - 1; });
  }

  function removeAll(variantId) {
    return changeQuantity(variantId, function () { return 0; });
  }

  function setProtection(on) {
    return enqueue(function () {
      return fetchCart().then(function (cart) {
        var sp = getSpConfig();
        if (!sp) return cart;
        var lines = cart.items.filter(function (item) { return isSpLine(item, sp); });
        var step = Promise.resolve(cart);
        if (on && !lines.length && pairCount(cart) > 0) {
          step = postThenRead('/cart/add.js', { items: [{ id: Number(sp.variantId), quantity: 1 }] });
        } else if (!on && lines.length) {
          var updates = {};
          lines.forEach(function (item) { updates[item.key] = 0; });
          step = postThenRead('/cart/update.js', { updates: updates });
        } else if (on && lines.length && (lines.length > 1 || lines[0].quantity !== 1)) {
          // Already on: make sure it's exactly one.
          var fix = {};
          lines.forEach(function (item, i) { fix[item.key] = i === 0 ? 1 : 0; });
          step = postThenRead('/cart/update.js', { updates: fix });
        }
        return step;
      });
    });
  }

  // Something else changed the cart (product page add to cart, quick add, Kaching widget): re-bundle and redraw.
  var externalTimer = null;
  function onExternalChange() {
    clearTimeout(externalTimer);
    externalTimer = setTimeout(function () {
      enqueue(function () {});
    }, 200);
  }

  window.LumveraCart = {
    addOne: addOne,
    removeOne: removeOne,
    removeAll: removeAll,
    setQuantity: setQuantity,
    setProtection: setProtection,
    refresh: function () { return enqueue(function () {}); },
    rememberMeta: rememberMeta,
    getCart: function () { return fetchCart().then(function (cart) { serverCart = cart; return cart; }); },
    getPairCount: function () { return model ? model.units.length : 0; },
    pricingReady: function () { return !!(kcConfig && model); },
    // What adding one pair of variantId would add to the cart total (cents), with Kaching's bundle prices applied.
    // null when the bundle settings or the cart aren't loaded yet.
    priceIfAdded: function (variantId) {
      if (!kcConfig || !model || !meta[String(variantId)]) return null;
      var units = model.units.slice();
      var before = buildPlan(units, kcConfig).estimate;
      var after = buildPlan(units.concat([String(variantId)]), kcConfig).estimate;
      return Math.max(0, after - before);
    },
    isBusy: function () { return pending > 0; }
  };

  // Drawer controls. Capture phase + stopImmediatePropagation so the theme's own quantity handlers never run.
  document.addEventListener('click', function (event) {
    var stepper = event.target.closest('#cart-drawer .quantity-selector__button');
    var trash = event.target.closest('#cart-drawer [data-lumvera-remove-line-item]');
    var target = stepper || trash;
    if (!target) return;

    var container = target.closest('line-item-quantity');
    var variantId = container && container.getAttribute('data-lumvera-variant-id');
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (trash) removeAll(variantId);
    else if (stepper.getAttribute('aria-label') === 'Increase quantity') addOne(variantId);
    else removeOne(variantId);
  }, true);

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-lv-sp-toggle]');
    if (toggle) {
      event.stopImmediatePropagation();
      setProtection(toggle.checked);
      return;
    }
    // Typed quantity in the drawer.
    var input = event.target.closest('#cart-drawer line-item-quantity input');
    if (input) {
      var container = input.closest('line-item-quantity');
      var variantId = container && container.getAttribute('data-lumvera-variant-id');
      if (!variantId) return;
      event.stopImmediatePropagation();
      setQuantity(variantId, parseInt(input.value, 10) || 0);
    }
  }, true);

  // Checkout waits until every change has been saved (max 8s), so checkout always gets the cart the drawer shows.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('#cart-drawer')) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout' || !pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitter.setAttribute('aria-busy', 'true');
    var started = Date.now();
    (function wait() {
      if (pending && Date.now() - started < 8000) { setTimeout(wait, 100); return; }
      window.location.href = '/checkout';
    })();
  }, true);

  // The theme's own add to cart (product page, quick add, Kaching widget) fires these.
  document.addEventListener('cart:change', onExternalChange);
  document.addEventListener('cart:refresh', onExternalChange);

  // On load: read the cart, warm Kaching's settings, and fix anything left over from before (bundles / protection).
  function preload() {
    var sp = getSpConfig();
    if (sp && !sp.price) {
      rawFetch('/products/shipping-protection.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { if (!spPrice) spPrice = product.variants[0].price; })
        .catch(function () {});
    }

    fetchCart().then(function (cart) {
      serverCart = cart;
      model = modelFromCart(cart);
      var url = firstProductUrl(model.units);
      return loadConfig(url).then(function () {
        if (cart.items.length) return enqueue(function () {});
        var link = document.querySelector('a[href*="/products/"]');
        if (link) loadConfig(link.getAttribute('href'));
      });
    }).catch(function () {});
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(preload, { timeout: 1500 });
  } else {
    setTimeout(preload, 300);
  }
})();

(function () {
  'use strict';

  var CARD_LIMIT = 8;
  var HALF_OFF_AT = 1; // with 1 pair in the cart, the next pair is the 2nd pair: 50% off

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Shipping Protection is a cart line but not a pair: it must not count toward the free/second pair
  // threshold, and it must not seed or appear in recommendations. Its product id comes from the
  // [data-lv-sp-config] element rendered in sections/cart-drawer.liquid.
  function getShippingProtectionProductId() {
    var config = document.querySelector('[data-lv-sp-config]');
    return config ? config.getAttribute('data-product-id') : null;
  }

  function productCardHtml(product, isHalfOff) {
    var image = product.featured_image || (product.images && product.images[0]) || null;
    var variant = (product.variants && product.variants[0]) || null;
    var variantId = variant ? variant.id : '';
    var price = variant ? variant.price : product.price;

    var imageHtml = image
      ? '<img src="' + escapeHtml(image) + (image.indexOf('?') === -1 ? '?width=416' : '&width=416') + '" loading="eager" decoding="async" alt="" style="width:100%;aspect-ratio:1;object-fit:cover;display:block;background:#eaeaeb;">'
      : '';

    var buttonLabel = '+ Add';

    if (window.LumveraCart && variant) {
      window.LumveraCart.rememberMeta(variant.id, {
        productId: String(product.id),
        price: price,
        title: product.title,
        image: image,
        url: product.url
      });
    }

    // With 1 pair in the cart the card shows what this pair really adds with the 2-pair bundle, next to its
    // crossed-out full price (e.g. AU: $64.95 -> $35.00 when 2 pairs are $99.95).
    var addPrice = isHalfOff && window.LumveraCart && window.LumveraCart.priceIfAdded && variant
      ? window.LumveraCart.priceIfAdded(variant.id)
      : null;
    var priceHtml = addPrice != null && addPrice < price
      ? '<sale-price class="bold" style="font-size:14px;color:#1D4ED8;">' + money(addPrice) + '</sale-price>' +
        '<compare-at-price class="text-subdued" style="font-size:12.5px;text-decoration:line-through;">' + money(price) + '</compare-at-price>'
      : '<sale-price class="bold" style="font-size:14px;">' + money(price) + '</sale-price>';

    return (
      '<div class="cart-bundle-card v-stack gap-2.5">' +
        '<a href="' + escapeHtml(product.url) + '" style="position:relative;display:block;border-radius:10px;overflow:hidden;">' +
          imageHtml +
        '</a>' +
        '<div class="v-stack gap-1" style="padding:0 2px;">' +
          '<a href="' + escapeHtml(product.url) + '" class="bold" style="letter-spacing:0.02em;font-size:12.5px;line-height:1.3;text-transform:uppercase;display:block;margin-bottom:7px;">' + escapeHtml(product.title) + '</a>' +
          '<price-list class="price-list h-stack gap-1.5" style="align-items:baseline;">' +
            priceHtml +
          '</price-list>' +
        '</div>' +
        '<div style="padding:0 2px 2px;">' +
          '<button type="button" class="button button--sm" style="width:100%;" data-lumvera-recommend-add="' + variantId + '">' + buttonLabel + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  var recommendationCache = {};

  function fetchRecommendationsFor(productId) {
    if (!recommendationCache[productId]) {
      recommendationCache[productId] = fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.products || []; })
        .catch(function () {
          delete recommendationCache[productId];
          return [];
        });
    }
    return recommendationCache[productId];
  }

  var lastSignature = null;

  function renderRecommendations() {
    var list = document.querySelector('[data-lumvera-recommendations-list]');
    if (!list) return;

    var cartRequest = window.LumveraCart
      ? window.LumveraCart.getCart()
      : fetch('/cart.js').then(function (r) { return r.json(); });

    cartRequest
      .then(function (cart) {
        var spProductId = getShippingProtectionProductId();
        var pairItems = cart.items.filter(function (item) { return String(item.product_id) !== spProductId; });
        var pairCount = pairItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        var cartProductIds = pairItems.map(function (item) { return item.product_id; });
        var uniqueCartProductIds = cartProductIds.filter(function (id, i) { return cartProductIds.indexOf(id) === i; });

        // "2nd pair 50% off": the label shows while there's exactly 1 pair, when the next one is the 2nd pair.
        var isHalfOff = pairCount === HALF_OFF_AT;
        var ready = !!(window.LumveraCart && window.LumveraCart.pricingReady && window.LumveraCart.pricingReady());
        var signature = pairCount + '|' + ready + '|' + uniqueCartProductIds.slice().sort().join(',');
        if (signature === lastSignature && list.children.length > 0) return;
        lastSignature = signature;

        if (pairCount === 0) {
          list.innerHTML = '';
          return;
        }

        return Promise.all(uniqueCartProductIds.map(fetchRecommendationsFor)).then(function (results) {
          var seen = {};
          var merged = [];

          results.forEach(function (products) {
            products.forEach(function (product) {
              if (cartProductIds.indexOf(product.id) !== -1) return;
              if (String(product.id) === spProductId) return;
              if (seen[product.id]) return;
              seen[product.id] = true;
              merged.push(product);
            });
          });

          merged = merged.slice(0, CARD_LIMIT);

          var wrapper = list.closest('[data-lumvera-recommendations]');

          if (merged.length === 0) {
            if (wrapper) wrapper.style.display = 'none';
            list.innerHTML = '';
            return;
          }

          if (wrapper) wrapper.style.display = '';
          list.innerHTML = merged.map(function (product) { return productCardHtml(product, isHalfOff); }).join('');
          ensureScrollListener();
        });
      })
      .catch(function () {});
  }

  document.addEventListener('cart:refreshed', renderRecommendations);
  document.addEventListener('lumvera:cart-synced', renderRecommendations);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecommendations);
  } else {
    renderRecommendations();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lumvera-recommend-add]');
    if (!button) return;

    var variantId = button.getAttribute('data-lumvera-recommend-add');
    if (!variantId) return;

    event.preventDefault();
    if (!window.LumveraCart) return;

    // The row appears in the drawer straight away (lumvera-cart controller); the card stays clickable.
    var label = button.textContent;
    button.textContent = 'Added ✓';
    window.LumveraCart.addOne(variantId);
    setTimeout(function () { button.textContent = label; }, 1200);
  });

  var CARD_SCROLL_AMOUNT = 220;

  function getRecommendationsList() {
    return document.querySelector('[data-lumvera-recommendations-list]');
  }

  function updateNavState() {
    var list = getRecommendationsList();
    var nav = document.querySelector('[data-lumvera-recommendations-nav]');
    if (!list || !nav) return;
    var prevBtn = nav.querySelector('[data-lumvera-scroll="prev"]');
    var nextBtn = nav.querySelector('[data-lumvera-scroll="next"]');
    var max = list.scrollWidth - list.clientWidth;
    if (prevBtn) prevBtn.disabled = list.scrollLeft <= 2;
    if (nextBtn) nextBtn.disabled = max <= 2 || list.scrollLeft >= max - 2;
  }

  // Custom rAF-driven smooth scroll. Native `scrollBy({behavior:'smooth'})` was tested extensively
  // in this drawer's rendering context and found to silently no-op unpredictably (roughly 1 in 10
  // attempts), so we drive the animation ourselves for a reliable, consistent slide every time.
  var activeScrollAnim = null;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateScrollBy(list, delta, duration) {
    if (activeScrollAnim) {
      cancelAnimationFrame(activeScrollAnim.rafId);
      activeScrollAnim = null;
    }

    var startLeft = list.scrollLeft;
    var maxScroll = list.scrollWidth - list.clientWidth;
    var targetLeft = Math.max(0, Math.min(maxScroll, startLeft + delta));
    var distance = targetLeft - startLeft;
    var startTime = null;
    var anim = { rafId: 0 };
    activeScrollAnim = anim;

    if (distance === 0) {
      activeScrollAnim = null;
      return;
    }

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      list.scrollLeft = startLeft + distance * easeOutCubic(progress);
      if (progress < 1) {
        anim.rafId = requestAnimationFrame(step);
      } else if (activeScrollAnim === anim) {
        activeScrollAnim = null;
      }
    }

    anim.rafId = requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var scrollBtn = event.target.closest('[data-lumvera-scroll]');
    if (!scrollBtn || scrollBtn.disabled) return;
    var list = getRecommendationsList();
    if (!list) return;
    var direction = scrollBtn.getAttribute('data-lumvera-scroll') === 'prev' ? -1 : 1;
    animateScrollBy(list, direction * CARD_SCROLL_AMOUNT, 320);
  }, true);

  var scrollListenerAttachedTo = null;

  function ensureScrollListener() {
    var list = getRecommendationsList();
    if (list && list !== scrollListenerAttachedTo) {
      list.addEventListener('scroll', updateNavState);
      scrollListenerAttachedTo = list;
    }
    updateNavState();
  }

  document.addEventListener('cart:refreshed', function () {
    setTimeout(ensureScrollListener, 0);
  });

  var scheduled = null;

  function scheduleRecommendationsCheck() {
    clearTimeout(scheduled);
    scheduled = setTimeout(renderRecommendations, 250);
  }

  function isInsideRecommendationsList(node) {
    var list = document.querySelector('[data-lumvera-recommendations-list]');
    return !!(list && (list === node || list.contains(node)));
  }

  var drawerObserver = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return !isInsideRecommendationsList(m.target);
    });
    if (relevant) scheduleRecommendationsCheck();
  });

  function attachDrawerObserver() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawerObserver.disconnect();
    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  attachDrawerObserver();
  document.addEventListener('cart:refreshed', attachDrawerObserver);
})();
